<div *ngVar="editing$ | async as editing" class="flex flex-col gap-5">
  <div class="text-navy-90 font-extrabold text-2xl px-7.5">{{ buildTranslationKey('compliance') | translate }}</div>

  <div cdkDropListGroup class="frameworks-container flex justify-center sm:justify-start flex-wrap gap-2 px-7.5 pb-7.5">
    <div
      #placeholder
      cdkDropList
      class="placeholder-drop-list"
      [cdkDropListDisabled]="!editing"
      (cdkDropListEntered)="onDropListEntered($event)"
      (cdkDropListDropped)="onDropListDropped()"
    ></div>
    @for (framework of frameworks; track framework.id) {
      @if (framework.is_visible) {
        <div
          cdkDropList
          [cdkDropListDisabled]="!editing"
          (cdkDropListEntered)="onDropListEntered($event)"
          (cdkDropListDropped)="onDropListDropped()"
        >
          <div
            class="trust-framework-item group relative"
            cdkDrag
            cdkDragBoundary=".frameworks-container"
            [cdkDragData]="framework"
          >
            <ng-container *ngTemplateOutlet="frameworkItem; context: { framework }"></ng-container>
            @if (editing$ | async) {
              <app-new-button
                cdkDragHandle
                class="cdk-drag-handle top-0 left-0 h-10 w-10 bg-navy-40 border border-navy-60 transform -translate-x-1/2 -translate-y-1/2"
                [svgIconPath]="'drag'"
                [isOnlyIcon]="true"
                [type]="'basic'"
                [size]="'tiny'"
              ></app-new-button>
            }
          </div>
        </div>
      } @else {
        <div class="group relative">
          <ng-container *ngTemplateOutlet="frameworkItem; context: { framework }"></ng-container>
        </div>
      }
    }
  </div>
</div>

<ng-template #frameworkItem let-framework="framework">
  <div
    class="font-main h-31 flex py-3 flex-col gap-2 items-center justify-start text-center w-25 group-hover:bg-navy-20 border border-transparent group-hover:border-navy-50 rounded-md cursor-pointer"
    (click)="openSidePanel(framework?.id)"
  >
    @if (!framework.is_visible) {
      <svg-icon class="w-6 h-6 right-1 top-1 absolute" [src]="'eye'"></svg-icon>
    }

    @if (framework.logo_url) {
      <img class="h-10.5" [class.opacity-50]="!framework.is_visible" [src]="framework.logo_url | safe: 'url'" />
    } @else {
      <svg-icon
        class="w-10.5 h-10.5"
        [class.opacity-50]="!framework.is_visible"
        [src]="getFrameworkIcon(framework.icon_id)"
      ></svg-icon>
    }

    <div
      class="text-navy-90 text-2xl font-bold w-full max-w-full overflow-hidden overflow-ellipsis whitespace-normal lines-clamp"
      [class.opacity-50]="!framework.is_visible"
      [ngbTooltip]="framework.name"
      [disableTooltip]="isMobile"
      [openTooltipWhenOverflowedAndHovered]="true"
      [openOnWidthOverflow]="true"
      [openOnHeightOverflow]="true"
      [placement]="'top'"
      [tooltipClass]="'default-tooltip'"
    >
      {{ framework.name }}
    </div>
  </div>
</ng-template>
